<script>
	import RoamEvents from "./roamEvents";
	import { getContext } from "svelte";
	import GrsDevices from "./grsDevices";
	import ReplayTimelineHandler from './replayTimeline'

	const flight = getContext("flight");
	const replayStore = flight.replayInfoStore
	const timelineHandler = flight.getHandler(ReplayTimelineHandler)
	const roams = flight.getHandler(RoamEvents);
	const grs = flight.getHandler(GrsDevices);

</script>

<div>
	{#each $roams as roam}
		<div
			class="roamDot"
			style={`left: ${timelineHandler.timeToPercent(roam.timestamp, $replayStore.currentLiveTimestamp) * 100}%;`}
		>
			{#if $grs[roam.currentId]}
				<div
					data-tooltip={`Roam to ${$grs[roam.currentId].name}`}
					class="tooltip"
				/>
			{/if}
		</div>
	{/each}
</div>

<style>
	.tooltip {
		width: 100%;
		height: 100%;
		position:relative;
	}

	.roamDot {
		position: absolute;
		height: 10px;
		width: 10px;
		background-color: #5189e1;
		border-radius: 50%;
		display: inline-block;
		border: 1px solid white;
		margin-top: -2px;
	}
</style>
